import React from 'react'

const Resume = () => {
  return (
    <section id="resume">
      <h2>Resume</h2>
      <h4>Future Section with Key Resume Details</h4>
      <p>This section is a work in progress</p>
      {/* FUTURE Create showing past employment etc. */}
    </section>
  )
}

export default Resume